import { create } from "zustand";

import { AvailableRoles } from "@/types";

interface AuthState {
  email: string | null;
  setEmail: (email: string | null) => void;
  onboardingData: {
    accountType: AvailableRoles | null;
    secondaryEmail: string | null;
    parentEmail: string | null;
    phoneNumber: string | null;
    firstName: string | null;
    lastName: string | null;
    birthDate: string | null;
    language: string | null;
    timezone: string | null;
  };
  setOnboardingData: (onboardingData: Partial<AuthState["onboardingData"]>) => void;
}

const useAuthStore = create<AuthState>()((set) => ({
  email: null,
  setEmail: (email) => {
    set(() => ({ email }));
  },
  onboardingData: {
    accountType: null,
    secondaryEmail: null,
    parentEmail: null,
    phoneNumber: null,
    firstName: null,
    lastName: null,
    birthDate: null,
    language: null,
    timezone: null,
  },
  setOnboardingData: (onboardingData) => {
    set((state) => ({ onboardingData: { ...state.onboardingData, ...onboardingData } }));
  },
}));

export default useAuthStore;
